import React from "react"
import Layout from "../../components/layout"
import Hero from "../../components/hero"
import OrgChart from "../../components/org-chart"
import ReadNext from "../../components/read-next"

export default function IMFOrganizationChart() {
  return (
    <Layout>
      <section className="page page--pullBottom page--margin-medium">
        <Hero
          title="Who We Are"
          text="The International Monetary Fund (IMF) is a global organization of 190 member countries set up to promote the health of the world economy."
          image="who-we-are/imf-organization-chart/hero.jpg"
        />

        <section className="org-chart">
          <header>
            <h2 className="title--l md:title--xl">IMF Organization Chart</h2>
          </header>
          <OrgChart />
        </section>

        <ol className="text-block__footnotes">
          <li>
            Known formally as the Joint Ministerial Committee of the Boards of
            Governors of the Bank and the Fund on the Transfer of Real Resources
            to Developing Countries.
          </li>
        </ol>
      </section>

      <ReadNext
        sectionID="who-we-are"
        pageID="executive-directors-management-team"
      />
    </Layout>
  )
}
